import * as React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font
} from "@react-pdf/renderer";
import ReportHeader from "../report/ReportHeader";
import { IReport3Applicant } from "../../../model/report/Report3Applicant";
import SagoeUi from "../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiItalic from "../../assets/fonts/a1f05a6515e69ab2886bdaaf1489d410.ttf";
import SagoeUiBold from "../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

const Report3Template = ({
  translate,
  data,
  title,
  subtitle,
  showTitle = true
}: {
  translate?: any;
  data: IReport3Applicant[];
  title?: string;
  subtitle?: string;
  showTitle?: boolean;
}) => {
  return (
    <Document title={subtitle}>
      <Page size="A4" style={styles.body}>
        <ReportHeader
          title={subtitle}
          translate={translate}
          subtitle={title}
          subtitleText={translate("reports.params.reporting_period")}
        />

        <View style={styles.table}>
          <View style={styles.tableRow}>
            <View style={styles.titleCell}>
              <Text style={styles.tableCell}>
                {translate("document_template.applicant_id")}
              </Text>
            </View>
            <View style={styles.titleCell}>
              <Text style={styles.tableCell}>
                {translate("document_template.party_id")}
              </Text>
            </View>
            <View style={styles.titleCell}>
              <Text style={styles.tableCell}>
                {translate("document_template.first_name")}
              </Text>
            </View>
            <View style={styles.titleCell}>
              <Text style={styles.tableCell}>
                {translate("document_template.father_name")}
              </Text>
            </View>
            <View style={styles.titleCell}>
              <Text style={styles.tableCell}>
                {translate("document_template.last_name")}
              </Text>
            </View>
            <View style={styles.titleCell}>
              <Text style={styles.tableCell}>
                {translate("document_template.mother_surname")}
              </Text>
            </View>
            <View style={styles.titleCell}>
              <Text style={styles.tableCell}>
                {translate("document_template.submit_reason")}
              </Text>
            </View>
            <View style={styles.titleCell}>
              <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                {translate("document_template.submited_reports_number")}
              </Text>
            </View>
            <View style={styles.titleCell}>
              <Text style={styles.tableCell}>
                {translate("document_template.submit_dates")}
              </Text>
            </View>
          </View>
          {data.map((item, index) => (
            <View style={styles.tableRow} key={index}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{item.applicantId}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{item.partyId}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{item.firstName} </Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{item.fatherName}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{item.lastName}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{item.motherSurname}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{item.submitReason}</Text>
              </View>
              <View style={styles.tableCol}>
                <Text style={{ ...styles.tableCell, textAlign: "right" }}>
                  {item.submitedReportsNumber}
                </Text>
              </View>
              <View style={styles.tableCol}>
                {(item.submitDates || []).map((date: string, index: number) => {
                  return (
                    <View
                      key={`${data}-${index}`}
                      style={{
                        ...styles.tableCol,
                        width: "100%",
                        borderWidth: 0
                      }}
                    >
                      <Text style={styles.tableCell}>{date.trim()}</Text>
                    </View>
                  );
                })}
              </View>
            </View>
          ))}
        </View>
        <Text
          style={styles.pageNumbers}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default Report3Template;

Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    {
      src: SagoeUiItalic,
      fontStyle: "italic"
    },
    { src: SagoeUi }
  ]
});


const styles = StyleSheet.create({
  body: {
    padding: "37pt 37pt 37pt 37pt"
  },
  titleCol: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#CDCDCD",
    padding: "0pt 5pt 5pt",
    marginLeft: "5pt",
    marginBottom: "5pt"
  },
  title: {
    fontSize: "14pt",
    height: "20pt",
    padding: "0pt 5pt 0pt 5pt",
    fontWeight: "bold",
    fontFamily: "Segoe UI"
  },
  subtitle: {
    fontSize: "8pt",
    padding: "0pt 5pt 0pt",
    fontFamily: "Segoe UI"
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    marginLeft: "5pt"
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol: {
    width: "11.11%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0
  },
  tableCell: {
    padding: "0pt 5pt 0pt 5pt",
    fontSize: "8pt",
    fontFamily: "Segoe UI"
  },
  titleCell: {
    width: "11.11%",
    borderStyle: "solid",
    borderWidth: 1,
    borderTopWidth: 0,
    backgroundColor: "#CDCDCD",
    padding: 2
  },
  previewTable: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftWidth: 0,
    flexDirection: "column"
  },
  previewRow: {
    margin: "auto",
    flexDirection: "row",
    width: "100%",
    display: "flex"
  },
  pageNumbers: {
    fontSize: 10,
    fontFamily: "Segoe UI",
    position: "absolute",
    bottom: "30pt",
    right: "37pt"
  }
});
